import { FormControl, MenuItem, TextField, withStyles } from '@material-ui/core';
import { SearchType } from 'connect/web/src/stores/search-store';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import type SearchBarStore from '../../stores/search-bar-store';
import styles from './styles';

interface IProps {
  searchBarStore?: SearchBarStore;
  className: string;
  classes: {
    searchType: string;
  };
}

@inject('searchBarStore')
@observer
class SearchTypeControl extends React.Component<IProps> {
  render() {
    const { searchMode, filteredTypes } = this.props.searchBarStore!;
    const { classes } = this.props;

    const types = filteredTypes.map((f) => {
      return (
        <MenuItem value={f}>
          {f === SearchType.Class ? 'Class' : f === SearchType.Appointment ? 'Appointment' : 'Both'}
        </MenuItem>
      );
    });
    return (
      <FormControl className={classes.searchType} variant="outlined">
        <TextField
          select={true}
          label="Appointment or Class?"
          value={searchMode}
          onChange={this.onChange}
          variant="outlined"
        >
          {types}
        </TextField>
      </FormControl>
    );
  }

  @action.bound
  onChange(e) {
    const { searchBarStore } = this.props;
    searchBarStore!.searchMode = e.target.value;
    const sId = searchBarStore!.serviceId.split('/')[0];
    if (!searchBarStore!.filteredServices.map((f) => f.id).includes(sId)) {
      searchBarStore!.serviceId = 'All';
    }

    if (
      !searchBarStore!.filteredLocations
        .map((f) => f.onlineGuid)
        .includes(searchBarStore!.locationId)
    ) {
      searchBarStore!.locationId = 'All';
    }
  }
}

export default withStyles(styles)(SearchTypeControl);
